/**
     * @desc 查询代币列表
用于：browse页，查询出所有代币信息列表
     */

import * as defs from '../../baseClass';
import { PontCore } from '../../pontCore';
import * as ajax from '../../../utils/request';

export class Params {}

export const init = new defs.Result();

export function request(params, body, options = {}) {
  return ajax.post('/paymentTokens/getPaymentTokensList', params);
}

export function upload(params, body, options = {}) {
  return ajax.upload('/paymentTokens/getPaymentTokensList', params);
}
